import { Box } from "@mui/material"
import { useCallback } from "react";
import FirebaseTitledCardsWithCTAButtonSection from "../Components/FirebaseTitledCardsWithCTAButtonSection"
import { PROJECTS_COLLECTION } from "../constants/collectionPaths"
import { useMicrospecThemeLanguageContext } from "../../MicrospecDynamicUI/Themes";

const ProjectsPage: React.FC = () => {
    const { localizationProvider } = useMicrospecThemeLanguageContext();

    const mapDocToCard = useCallback((doc: any) => ({
        id: doc.id,
        mediaUrl: Array.isArray(doc.mediaUrls) && doc.mediaUrls.length > 0 ? doc.mediaUrls[0] : doc.image,
        icon: doc.icon,
        title: localizationProvider.translate(doc.name) ?? '',
        href: `/projects/${doc.id}`,
    }), [localizationProvider]);

    return (
        <Box>
            <FirebaseTitledCardsWithCTAButtonSection spec={{
                collectionPath: PROJECTS_COLLECTION,
                mapDocToCard,
                id: 'projects',
                sectionTitle: {
                    localizationObject: {
                        type: 'Literal',
                        text: 'גלריית פרויקטים'
                    }
                },
                orderField: 'order',
                orderDirection: 'asc',
            }} />
        </Box>
    );
};

export default ProjectsPage;
